import { Component, Input,Output,  ChangeDetectionStrategy, EventEmitter } from '@angular/core';

@Component({
  selector: 'sidebar-coverage',
  templateUrl: 'sidebar-coverage.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarCoverageComponent {
  @Output() goToSection: EventEmitter<any> = new EventEmitter();
  @Input() sectors: any = [];
  @Input() regions: any = [];
  @Input() sidebar: string;

  constructor() {
  }

  goSection(section){
    this.goToSection.emit(section);
  }

}



// WEBPACK FOOTER //
// ./src/components/sidebar-coverage/sidebar-coverage.ts